var exports = {
  "Qs": "AddGuildModal.module__content___WjRzdW",
  "lF": "AddGuildModal.module__footerReveal___WjRzdW",
  "BT": "AddGuildModal.module__landingContainer___WjRzdW",
  "Xg": "AddGuildModal.module__actionButtonsGroup___WjRzdW",
  "uu": "AddGuildModal.module__actionButtons___WjRzdW",
  "hP": "AddGuildModal.module__actionButton___WjRzdW",
  "gE": "AddGuildModal.module__actionIcon___WjRzdW",
  "ZJ": "AddGuildModal.module__actionLabel___WjRzdW",
  "KJ": "AddGuildModal.module__formContainer___WjRzdW",
  "r2": "AddGuildModal.module__iconSection___WjRzdW",
  "ff": "AddGuildModal.module__iconSectionInner___WjRzdW",
  "go": "AddGuildModal.module__iconLabel___WjRzdW",
  "O2": "AddGuildModal.module__iconPreview___WjRzdW",
  "Dp": "AddGuildModal.module__iconImage___WjRzdW",
  "Pz": "AddGuildModal.module__iconPlaceholder___WjRzdW",
  "D_": "AddGuildModal.module__iconActions___WjRzdW",
  "Nu": "AddGuildModal.module__iconButtons___WjRzdW",
  "m5": "AddGuildModal.module__iconError___WjRzdW",
  "I4": "AddGuildModal.module__guidelines___WjRzdW",
  "YC": "AddGuildModal.module__guidelinesLink___WjRzdW",
  "$J": "AddGuildModal.module__templatePreview___WjRzdW",
  "pT": "AddGuildModal.module__templateInfo___WjRzdW",
  "x7": "AddGuildModal.module__templateLabel___WjRzdW",
  "G": "AddGuildModal.module__templateName___WjRzdW",
  "qt": "AddGuildModal.module__templateStats___WjRzdW",
  "W4": "AddGuildModal.module__openApiUrlButton___WjRzdW",
  "OJ": "AddGuildModal.module__verificationNotice___WjRzdW",
};

module.exports = exports;
